module.exports = __webpack_public_path__ + "img/39.2.TN.ef4c8c12.png";